/**
 * Business logic per Cross Company Job Orders autocomplete
 * Pura - senza dipendenze da Vue
 */

import { isArray } from 'lodash-es';
import crossCompanyMirrorConfigsService from '../services/crossCompanyMirrorConfigsService';
import type { JobOrderAutocompleteResult } from '../models/jobOrder';
import type { ODataQueryBuilder } from './types';
import type { ODataContext } from '~/mixins/filterHandler/types';

export interface CrossCompanyTargetJobOrdersOptions {
	targetCompany: string;
	searchString?: string;
	id?: number | string | null;
	notInIds?: Array<number | string> | null;
}

export async function getCrossCompanyTargetJobOrdersAutocomplete(
	buildQuery: ODataQueryBuilder,
	options: CrossCompanyTargetJobOrdersOptions,
): Promise<JobOrderAutocompleteResult[]> {
	const { targetCompany, searchString = '', id = null, notInIds = null } = options;

	const context: ODataContext = {
		select: 'id,code,name',
		expand: {
			customer: {
				select: 'id,code,name',
			},
		},
		top: 20,
		orderBy: ['endDate desc', 'name'],
		filter: {
			and: [],
		},
	};

	if (searchString !== '') {
		context.filter!.and!.push({
			or: [
				{ 'tolower(code)': { contains: searchString } },
				{ 'tolower(name)': { contains: searchString } },
				{ 'tolower(customer/code)': { contains: searchString } },
				{ 'tolower(customer/name)': { contains: searchString } },
			],
		});
	} else if (id) {
		context.filter!.and!.push({ id: { eq: id } });
	}

	if (notInIds && isArray(notInIds) && notInIds.length > 0) {
		context.filter!.and!.push({
			not: [
				{
					id: {
						in: notInIds,
					},
				},
			],
		});
	}

	const result = await crossCompanyMirrorConfigsService.getCrossCompanyJobOrders(
		targetCompany,
		buildQuery(context),
	);
	return result;
}
